import React from "react";
import { FormControl } from "react-bootstrap";

function CustomInput({
  className = "",
  id,
  type = "text",
  placeholder,
  name,
  value,
  customObjectKey,
  onClick,
  inputAs = "input",
  readOnly = false,
  checked,
  ...props
}) {
  return (
    <FormControl
      className={className}
      id={id}
      type={type}
      placeholder={placeholder}
      name={name}
      value={type === "checkbox" ? undefined : value}
      checked={type === "checkbox" ? checked : undefined}
      data-validationkey={customObjectKey}
      as={inputAs}
      onClick={onClick}
      readOnly={readOnly}
      {...props}
    />
  );
}

export default CustomInput;
